import { Dispatch } from 'redux'
import {
  apiRequest,
  apiFailure,
  getSupportSocials as getSupportSocialsReducer,
  sendSupportMessage as sendSupportMessageReducer,
} from 'reducers/support.reducer'
import { supportService } from 'services/support.service'
import { ISupportMutation } from 'models/Support/ISupport'

export const getSupportSocials = () => async (dispatch: Dispatch) => {
  try {
    dispatch(apiRequest())

    const response = await supportService.getSupportSocials()
    if (response) {
      const supportSocials = response

      dispatch(getSupportSocialsReducer({ supportSocials }))
    }
  } catch (error) {
    console.error(error)
    dispatch(apiFailure())
  }
}

export const sendSupportMessage =
  (supportInfo: ISupportMutation) => async (dispatch: Dispatch) => {
    try {
      dispatch(apiRequest())

      const response = await supportService.sendSupportMessage(supportInfo)
      if (response) {
        const supportMessageResponse = response
        dispatch(sendSupportMessageReducer({ supportMessageResponse }))
      }
    } catch (error) {
      console.error(error)
      dispatch(apiFailure())
    }
  }
